export default function getAvatar(avatarId) {
  return `${process.env.REACT_APP_MONIBRAND_BACKEND_API_URL}/Files/${avatarId}/get`;
}